import queryString from "query-string";

export default function useQuery() {
  return queryString.parse(window.location.search);
}
